
<template>
  <TheGreyWrapper>
    <TheHeader
      force-sm-style
      with-cross
      @close="close()"
    />
    <BaseSection>
      <BaseTitleGroup
        :title="$t('Thanks')"
        class="mb-4"
      />
      <div class="mb-6">
        <img src="../../assets/completed-documents.svg">
      </div>
      <BaseParagraph class="mb-4">
        {{ $t('Kerala team review') }}
      </BaseParagraph>
      <BaseButton
        :title="$t('Next')"
        to="/opportunities"
        class="mb-8"
      />
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { mapActions } from 'vuex';
import TheHeader from '../../components/TheHeader.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseButton from '../../components/BaseButton.vue';
import BaseParagraph from '../../components/BaseParagraph.vue';
import TheGreyWrapper from '../../components/TheGreyWrapper.vue';

export default {
  name: 'Success',
  components: {
    TheHeader,
    BaseTitleGroup,
    BaseButton,
    BaseSection,
    BaseParagraph,
    TheGreyWrapper,
  },
  created() {
    this.submit();
    this.fetch();
  },
  methods: {
    ...mapActions('kyc', ['submit', 'fetch']),
    close() {
      this.$router.push('/opportunities');
    },
  },
};
</script>
